'use client'

import cn from 'clsx'

import { SyncLoader } from 'react-spinners'

import s from './Loading.module.sass'

function Loading({
    loading = true,
    size = 15,
    fullHeight,
    dark,
}: {
    loading?: boolean
    size?: number
    fullHeight?: boolean
    dark?: boolean
}) {
    return (
        <div className={cn(s.Loading, fullHeight && s.FullHeight)}>
            <div>
                <SyncLoader
                    color={dark ? 'var(--colour-sky-blue)' : 'var(--colour-royal-blue)'}
                    loading={loading}
                    size={size}
                />
            </div>
        </div>
    )
}

export default Loading
